import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TimerCompleteModal = ({ open, onClose, label, emoji }) => {
  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[250] flex items-center justify-center px-6">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.88, y: 16 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ type: 'spring', damping: 24, stiffness: 300 }}
            className="relative z-10 w-full max-w-xs bg-[#0e1829] border border-white/10 rounded-3xl p-6 shadow-2xl"
          >
            <div className="flex justify-center mb-4">
              <div className="w-20 h-20 rounded-2xl bg-rose-500/15 border border-rose-500/25 flex items-center justify-center text-5xl animate-pulse">
                {emoji || '⏰'}
              </div>
            </div>
            <h3 className="text-2xl font-black text-white text-center mb-2">時間到！</h3>
            <p className="text-base text-white/60 text-center mb-6 font-bold">{label || '計時結束'}</p>
            <button
              onClick={onClose}
              className="w-full py-3.5 bg-rose-500 hover:bg-rose-400 text-white font-black rounded-2xl transition-all active:scale-95 text-base"
            >
              知道了
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default TimerCompleteModal;